import type { OrganizationContextLabelProps } from "./organization-context-label.type";

import { Flex, Typography } from "antd";
import classNames from "classnames";

import ModelIcon from "@/modules/model-icon";

import { useOrganizationContextLabel } from "./organization-context-label.hook";

import "./organization-context-label.style.less";

const { Text } = Typography;

export const OrganizationContextLabel = ({
  context,
  isSmall,
}: OrganizationContextLabelProps) => {
  const { organization } = useOrganizationContextLabel(context);

  if (!organization) return null;

  return (
    <Flex
      className={classNames("organization-context-label", { "-sm": isSmall })}
    >
      <ModelIcon model="organization" />
      <Text>{organization.name}</Text>
    </Flex>
  );
};
